import { useRef, useState } from "react";
import Website_Link from "../../../Assets/Website_Link.svg";
import minusIcon_spinner from "../../../Assets/minusIcon_spinner.svg";
import plusIcon_spinner from "../../../Assets/plusIcon_spinner.svg";
import documentresponse_icon from "../../../Assets/documentresponse_icon.svg";
import SignatureCanvas from "react-signature-canvas";
import formFileUploadIcon from "../../../Assets/formFileUploadIcon.svg";
import trash_icon from "../../../Assets/trash_icon.svg";
import close_icon from "../../../Assets/close_icon.svg";
import trash_icon_del from "../../../Assets/trash_icon_del.svg";
import "react-datepicker/dist/react-datepicker.css";
import calendarIcon from "../../../Assets/calendarIcon.svg";
import startquestion_icon from "../../../Assets/startquestion_icon.svg";
import addrating_icon from "../../../Assets/addrating_icon.svg";
import thumbsuprating_icon from "../../../Assets/thumbsuprating_icon.svg";
import heartrating_icon from "../../../Assets/heartrating_icon.svg";
import balloonrating_icon from "../../../Assets/balloonrating_icon.svg";
import flagrating_icon from "../../../Assets/flagrating_icon.svg";
import basketballrating_icon from "../../../Assets/basketballrating_icon.svg";
import selected_startquestion_icon from "../../../Assets/selected_startquestion_icon.svg";
import selected_addrating_icon from "../../../Assets/selected_addrating_icon.svg";
import selected_thumbsuprating_icon from "../../../Assets/selected_thumbsuprating_icon.svg";
import selected_heartrating_icon from "../../../Assets/selected_heartrating_icon.svg";
import selected_balloonrating_icon from "../../../Assets/selected_balloonrating_icon.svg";
import selected_flagrating_icon from "../../../Assets/selected_flagrating_icon.svg";
import selected_basketballrating_icon from "../../../Assets/selected_basketballrating_icon.svg";
import "react-datepicker/dist/react-datepicker.css";
import { LocalizationProvider, renderTimeViewClock } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import {
  checkBoxResponse,
  dateTimeResponses,
  dateUpdateResponse,
  deleteFile,
  dropDownResponses,
  lineScaleResponse,
  multipleChoiceResponse,
  multipleChoiceResponses,
  nameResponses,
  phoneResponses,
  signatureResponse,
  spinnerResponse,
  updateCheckBoxResponses,
  updateEmailResponse,
  updateFiles,
  updateLocation,
  updateNumber,
  updateResponse,
  websiteResponse,
} from "../../../Redux/Reducer/ResponseSlices";

const LineScale = ({ question, index, getAnswerValue }) => {
  const dispatch = useDispatch();
  const handleChange = (questionId, event) => {
    const value = parseInt(event);
    console.log(questionId);
    dispatch(lineScaleResponse({ questionId, value }));
  };
  const renderScale = () => {
    const scale = [];
    for (let i = question.minRange.value; i <= question.maxRange.value; i++) {
      scale.push(
        <label key={i} className="scale-option">
          <span className="scale-label">{i}</span>
          <input
            type="radio"
            name="scale"
            value={i}
            checked={getAnswerValue(question._id) === i}
            onChange={(e) => handleChange(question._id, e.target.value)}
            className="scale-radio"
          />
        </label>
      );
    }
    return scale;
  };
  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div className="Line_scale">
          <span>{question.minValue}</span>
          {renderScale()}
          <span>{question.maxValue}</span>
        </div>
        {/* <div className="Line_scale">
          <div>{question.maxRange.labelName}</div>
          {divs}
          <div>{question.minRange.labelName}</div>
        </div> */}
      </div>
    </div>
  );
};

const ShortAnswer = ({
  question,
  index,
  getAnswerValue,
  handleInputChange,
}) => {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const handleValidation = (value) => {
    // Character type validation
    if (question.character) {
      switch (question.character) {
        case "Letters only":
          
          if (!/^[a-zA-Z\s]*$/.test(value)) {
            return "Only letters are allowed.";
          }
          break;
        case "Letters number":
          if (!/^[a-zA-Z0-9\s]*$/.test(value)) {
            return "Only letters and numbers are allowed.";
          }
          break;
        case "numbers":
          if (!/^[0-9\s]*$/.test(value)) {
            return "Only numbers are allowed.";
          }
          break;
        case "Any character":
        default:
          break; // No restriction
      }
    }

    return ""; // No errors
  };
  const handleValidationOnBlur = (value) => {
    const trimmedValue = value.trim();
    const wordCount =
      trimmedValue.length > 0 ? trimmedValue.split(/\s+/).length : 0;

    // Check if the question is required and if the input is empty
    if (question.required && trimmedValue.length === 0) {
      return "This field is required.";
    }
    // Word limit validation
    if (wordCount < question.minWords) {
      return `Minimum ${question.minWords} words required.`;
    }
    if (wordCount > question.maxWords) {
      return `Maximum ${question.maxWords} words allowed.`;
    }

    return ""; // No errors
  };

  const handelChange = (value) => {
    const validationError = handleValidation(value);

    setErrorMessage(validationError);
    if (!validationError) {
      dispatch(updateResponse({ questionId: question._id, value }));
    }
  };
  const handleBlur = (value) => {
    const validationError = handleValidationOnBlur(value);
    setErrorMessage(validationError);
  };
  return (
    <div
      className="answer_container"
      style={{ border: errorMessage && "2px solid red" }}
    >
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
          {question.required && <div style={{ color: "red" }}>*</div>}
        </div>
        <div className="input_container">
          <input
            className="individualView_input"
            placeholder={question.placeHolder}
            value={getAnswerValue(question._id)}
            onBlur={(e) => handleBlur(e.target.value)}
            onChange={(e) => handelChange(e.target.value, question.type)}
          />

          <div className="focus-underline"></div>
        </div>
        <p style={{ color: "red" }}>{errorMessage}</p>
      </div>
    </div>
  );
};

const ParagraphAnswer = ({
  question,
  index,
  getAnswerValue,
  handleInputChange,
}) => {
  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div className="input_container">
          <textarea
            className="individualView_input"
            placeholder={question.placeHolder}
            value={getAnswerValue(question._id)}
            onChange={(e) =>
              handleInputChange(question._id, e.target.value, question.type)
            }
          />
          <div className="focus-underline"></div>
        </div>
      </div>
    </div>
  );
};

const MultipleChoice = ({ question, index, getAnswerValue }) => {
  const dispatch = useDispatch();
  const handelChangeValue = (value, checked) => {
    dispatch(
      multipleChoiceResponse({ questionId: question._id, value, checked })
    );
  };
  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div className="questionView_OPtionContainer">
          {question.options.map((option, i) => (
            <label className="custom-radio" key={i}>
              <input
                type="radio"
                name="option"
                value={option.optionText}
                checked={(getAnswerValue(question._id) || []).includes(
                  option.optionText
                )}
                onChange={(e) =>
                  handelChangeValue(e.target.value, e.target.checked)
                }
              />
              <span className="custom-radio-mark"></span>
              {option.optionText}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

// const MultipleChoiceImage = ({ question, index }) => {
//   const isAnyOptionTextLong = question.options.some(
//     (option) => option.optionText.length > 35
//   );
//   return (
//     <div className="ShortAnswer_container">
//       <div className="Questionview_container">
//         {index + 1}.<div className="Questionview_text">{question.question}</div>
//       </div>
//       <div
//         className="questionView_OPtionContainer"
//         style={{
//           flexDirection: isAnyOptionTextLong ? "column" : "row",
//           display: "flex",
//           justifyContent: "space-between",
//         }}
//       >
//         {question.options.map((option, i) => (
//           <div
//             className="question_response_choice"
//             key={i}
//             style={{
//               fontSize: "0.875rem",
//               display: "flex",
//               flexDirection: isAnyOptionTextLong ? "row" : "column",
//             }}
//           >
//             <img src={option.optionImage} alt="optionImage" />
//             <img
//               src={
//                 option.optionText === question.selectedOption
//                   ? checkBoxResponse_icon
//                   : singleChoiceIcon
//               }
//               alt="singleChoiceIcon"
//             />
//             <div className="">{option.optionText}</div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

const CheckBox = ({ question, index, getAnswerValue, handleInputChange }) => {
  const dispatch = useDispatch();
  const handleCheckBoxResponse = (value, checked) => {
    dispatch(
      checkBoxResponse({
        questionId: question._id,
        value: value,
        checked: checked,
      })
    );
  };

  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div className="questionView_OPtionContainer">
          {question.options.map((option, i) => (
            <label key={i} className="custom-checkbox">
              <input
                type="checkbox"
                name="option"
                value={option.optionText}
                checked={getAnswerValue(question._id).includes(
                  option.optionText
                )}
                onChange={(e) =>
                  handleCheckBoxResponse(
                    e.target.value,
                    e.target.checked,
                    question.type
                  )
                }
              />
              <span className="custom-checkbox-mark"></span>
              {option.optionText}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

const GridBox = ({ question, index }) => {
  const dispatch = useDispatch();
  const handleInputChange = (questionId, value, rowText, rowId) => {
    console.log(questionId, rowText, value);
    dispatch(
      multipleChoiceResponses({
        questionId,
        value,
        rowText,
        rowId,
      })
    );
  };

  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <table>
          <thead>
            <tr>
              <th></th>
              {question.column.map((column, colIndex) => (
                <th key={colIndex}>{column.columnText}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {question.row.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.rowText}</td>
                {question.column.map((column, colIndex) => (
                  <td key={colIndex}>
                    <input
                      type="radio"
                      className="radiobtn-gridBox"
                      name={`row-${rowIndex}`}
                      value={column.columnText}
                      onChange={(e) =>
                        handleInputChange(
                          question._id,
                          column.columnText,
                          row.rowText,
                          row._id
                        )
                      }
                      aria-label={`${row.rowText} - ${column.columnText}`}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const CheckBoxGrid = ({ question, index }) => {
  const dispatch = useDispatch();
  const responses = useSelector((state) => state.responses.responses);
  const handleInputChange = (
    questionId,
    rowId,
    columnId,
    rowText,
    columnText,
    isChecked
  ) => {
    dispatch(
      updateCheckBoxResponses({
        questionId,
        rowText,
        columnText,
        rowId,
        isChecked,
        columnId,
      })
    );
  };
  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <table>
          <thead>
            <tr>
              <th></th>
              {question.column.map((column, colIndex) => (
                <th key={colIndex}>{column.columnText}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {question.row.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.rowText}</td>
                {question.column.map((column, colIndex) => (
                  <td key={colIndex}>
                    <input
                      type="checkbox"
                      name={`${question._id}-${row._id}-${column._id}`}
                      checked={
                        responses.responses
                          .find(
                            (response) => response.questionId === question._id
                          )
                          ?.answer.find((ans) => ans.rowText === row.rowText)
                          ?.values.includes(column.columnText) || false
                      }
                      onChange={(e) =>
                        handleInputChange(
                          question._id,
                          row._id,
                          column._id,
                          row.rowText,
                          column.columnText,
                          e.target.checked
                        )
                      }
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const Phone = ({ question, index, getAnswerValue }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(question.answer);

  const dispatch = useDispatch();

  const handleChange = (e) => {
    // setPhoneNumber(e.target.value);
    dispatch(
      phoneResponses({ questionId: question._id, value: e.target.value })
    );
  };
  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div className={`phone_number_container ${isFocused ? "focused" : ""}`}>
          {/* <div className="individual_Phone"> */}
          <p>+91</p>
          <input
            type="number"
            className="Answer_Phone"
            placeholder={question.placeHolder}
            value={getAnswerValue(question._id)}
            onChange={handleChange}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          />
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

const Name = ({ question, index }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const dispatch = useDispatch();
  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
    dispatch(
      nameResponses({
        questionId: question._id,
        answer: { firstName: e.target.value, lastName: lastName },
      })
    );
  };
  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
    dispatch(
      nameResponses({
        questionId: question._id,
        answer: { firstName, lastName: e.target.value },
      })
    );
  };
  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div className="individual_nameAns_container">
          <input
            className="Answer_FirstName"
            value={firstName}
            name="firstName"
            placeholder={question.firstNamePlaceHolder}
            onChange={(e) => handleFirstNameChange(e)}
          />

          <input
            className="Answer_lastName"
            value={lastName}
            name="lastName"
            placeholder={question.lastNamePlaceHolder}
            onChange={(e) => handleLastNameChange(e)}
          />
        </div>
      </div>
    </div>
  );
};

const Website = ({ question, index, getAnswerValue }) => {
  const dispatch = useDispatch();
  const [isFocused, setIsFocused] = useState("");

  const handleChange = (questionId, value) => {
    // setWebsite(e.target.value);
    dispatch(websiteResponse({ questionId, value }));
  };
  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        {/* <div className="nameAns_container"> */}
        <div className={`phone_number_container ${isFocused ? "focused" : ""}`}>
          {/* <div className="individual_Phone"> */}
          <img src={Website_Link} alt="Website_Link" />
          <input
            type="text"
            className="Answer_Phone"
            placeholder={question.placeHolder}
            value={getAnswerValue(question._id)}
            onChange={(e) => handleChange(question._id, e.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          />
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

const Location = ({ question, index, getAnswerValue }) => {
  const dispatch = useDispatch();
  const responses = useSelector((state) => state.responses.responses);
  const handelChange = (value, name, type) => {
    console.log(responses.responses);
    // console.log(getAnswerValue(question._id)==="");
    dispatch(updateLocation({ questionId: question._id, name, value, type }));
  };
  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div className="nameAns_container" style={{ height: "auto" }}>
          <div className="address-container">
            {question.address?.map(
              (address, i) =>
                address.type === "address" && (
                  <div
                    className="input_container"
                    style={{ width: "100%" }}
                    key={i}
                  >
                    {/* <div className="addresslineone" key={i}> */}
                    {/* <p>{address.placeHolder}</p> */}
                    <input
                      className="individualView_input"
                      placeholder={address.optionText}
                      value={
                        getAnswerValue(question._id) === ""
                          ? ""
                          : getAnswerValue(question._id).filter(
                              (value) => value.name === address.placeHolder
                            ).value
                      }
                      // onBlur={(e) => handleBlur(e.target.value)}
                      onChange={(e) =>
                        handelChange(
                          e.target.value,
                          address.placeHolder,
                          address.type
                        )
                      }
                    />

                    <div className="focus-underline"></div>
                    {/* </div> */}
                  </div>
                )
            )}
            <div className="other-details-container">
              {question.address?.map(
                (address, i) =>
                  address.type === "text" && (
                    <div
                      className="addresslineone"
                      key={i}
                      style={{ color: "#1b2436" }}
                    >
                      <input
                        type="email"
                        className="Answer_Phone"
                        placeholder={address.optionText}
                        value={
                          getAnswerValue(question._id) === ""
                            ? ""
                            : getAnswerValue(question._id).filter(
                                (value) => value.name === address.placeHolder
                              ).value
                        }
                        onChange={(e) =>
                          handelChange(
                            e.target.value,
                            address.placeHolder,
                            address.type
                          )
                        }
                        // onFocus={() => setIsFocused(true)}
                        // onBlur={() => setIsFocused(false)}
                      />

                      <div className="focus-underline"></div>
                    </div>
                  )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Email = ({ question, index, getAnswerValue }) => {
  const [isFocused, setIsFocused] = useState("");
  const dispatch = useDispatch();
  const handleInputChange = (questionId, value) => {
    dispatch(updateEmailResponse({ questionId, value }));
  };
  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div className={`phone_number_container ${isFocused ? "focused" : ""}`}>
          {/* <div className="individual_Phone"> */}
          <img src={Website_Link} alt="Website_Link" />
          <input
            type="email"
            className="Answer_Phone"
            placeholder={question.placeHolder}
            value={getAnswerValue(question._id)}
            onChange={(e) => handleInputChange(question._id, e.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          />
        </div>
      </div>
    </div>
  );
};

const Number = ({ question, index, getAnswerValue }) => {
  const dispatch = useDispatch();
  const handleNumberChange = (questionId, value) => {
    dispatch(updateNumber({ questionId, value }));
  };
  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div className="nameAns_container">
          <input
            className="Answer_Number"
            value={getAnswerValue(question._id)}
            type="String"
            placeholder={question.placeHolder}
            onChange={(e) => handleNumberChange(question._id, e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

const Spinner = ({ question, index, getAnswerValue }) => {
  const [value, setValue] = useState(
    getAnswerValue(question._id) ? getAnswerValue(question._id) : 0
  );
  const dispatch = useDispatch();
  const handleIncrement = () => {
    console.log(getAnswerValue(question._id) < question.maxValue);
    if (getAnswerValue(question._id) === "") {
      dispatch(
        spinnerResponse({
          questionId: question._id,
          value: 0 + question.intervalAmount,
        })
      );
    } else {
      if (getAnswerValue(question._id) < question.maxValue) {
        dispatch(
          spinnerResponse({
            questionId: question._id,
            value: getAnswerValue(question._id) + question.intervalAmount,
          })
        );
      }
    }
  };

  const handleDecrement = () => {
    if (getAnswerValue(question._id) === "") {
      dispatch(
        spinnerResponse({
          questionId: question._id,
          value: 0,
        })
      );
    } else {
      if (getAnswerValue(question._id) > question.minValue) {
        dispatch(
          spinnerResponse({
            questionId: question._id,
            value: getAnswerValue(question._id) - question.intervalAmount,
          })
        );
      }
    }
  };

  const handleChange = (e) => {
    setValue(parseFloat(e.target.value));
    const newValue = parseInt(e.target.value);
    if (
      !isNaN(newValue) &&
      newValue >= question.minValue &&
      newValue <= question.maxValue
    ) {
      dispatch(
        spinnerResponse({
          questionId: question._id,
          value: newValue,
        })
      );
    }
  };
  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div className="nameAns_container">
          <div
            className="Name"
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingRight: "0.6rem",
              color: "#1b2436",
            }}
          >
            <div
              style={{
                width: "9%",
                height: "70%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={handleDecrement}
            >
              <img src={minusIcon_spinner} alt="minusIcon_spinner" />
            </div>
            <input
              type="number"
              className="answerr_spinner"
              value={
                getAnswerValue(question._id) === ""
                  ? 0
                  : getAnswerValue(question._id)
              }
              onChange={handleChange}
            />
            <div
              style={{
                width: "9%",
                height: "70%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={handleIncrement}
            >
              <img src={plusIcon_spinner} alt="plusIcon_spinner" />
            </div>
          </div>
        </div>
        {/* <input
          type="number"
          onChange={(e) => console.log(typeof e.target.value)}
        /> */}
      </div>
    </div>
  );
};

const Signature = ({ question, index }) => {
  const canvasRef = useRef(null);
  const dispatch = useDispatch();
  const [signature, setSignature] = useState(
    question.answer?.signature || null
  );

  const handleMouseDown = (e) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const context = canvas.getContext("2d");
    context.beginPath();
    const { offsetX, offsetY } = e.nativeEvent || e; // Correctly handle the event
    context.moveTo(offsetX, offsetY);
    canvas.addEventListener("mousemove", handleMouseMove);
    canvas.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const context = canvas.getContext("2d");
    const { offsetX, offsetY } = e.nativeEvent || e; // Correctly handle the event
    context.lineTo(offsetX, offsetY);
    context.stroke();
  };

  const handleMouseUp = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    canvas.removeEventListener("mousemove", handleMouseMove);
    canvas.removeEventListener("mouseup", handleMouseUp);
    const dataURL = canvas.toDataURL("image/png");
    setSignature(dataURL);
  };

  const sigCanvas = useRef(null);

  const handleClear = (questionId) => {
    sigCanvas.current.clear();
    dispatch(signatureResponse({ questionId, value: "" }));
  };

  const handleSave = (questionId) => {
    const dataURL = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
    console.log(dataURL); // Save or process the signature image as needed
    dispatch(signatureResponse({ questionId, value: dataURL }));
  };
  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div
          style={{
            width: question.boxWidth || 400,
            height: question.boxHeight || 200,
            border: "1px solid #D3DCE5",
            borderRadius: "1rem",
          }}
        >
          <SignatureCanvas
            ref={sigCanvas}
            penColor="black"
            canvasProps={{
              className: "signature-canvas",
            }}
          />
        </div>
        {/* {signature && (
        )} */}
        <div className="signature-actions">
          <button
            onClick={() => handleClear(question._id)}
            className="clear-button"
          >
            Clear
          </button>
          <button
            onClick={() => handleSave(question._id)}
            className="save-button"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

const VAFileUpload = ({ question, index }) => {
  const [files, setFiles] = useState([]);
  const dispatch = useDispatch();
  const [fileErrors, setFileErrors] = useState({});
  const [error, setError] = useState("");

  const handleFileChange = (event) => {
    setError("");
    const selectedFiles = Array.from(event.target.files);
    const validFileTypes = question.fileTypes
      ? question.fileTypes.map((type) => type.trim().toLowerCase())
      : []; // Default to empty if no fileTypes provided
    const maxFileSize = parseFileSize(question.fileSizeMax);
    const minFileSize = parseFileSize(question.fileSizeMin);

    let newFiles = [];
    let newFileErrors = {};

    selectedFiles.forEach((file) => {
      const fileType = file.type.split("/")[1].toLowerCase();
      if (validFileTypes.length > 0 && !validFileTypes.includes(fileType)) {
        newFileErrors[file.name] = `Invalid file type: ${
          file.name
        }. Allowed types are: ${validFileTypes.join(", ")}.`;
      } else if (file.size > maxFileSize) {
        newFileErrors[
          file.name
        ] = `File ${file.name} exceeds the maximum size of ${question.fileSizeMax}.`;
      } else if (file.size < minFileSize) {
        newFileErrors[
          file.name
        ] = `File ${file.name} is smaller than the minimum size of ${question.fileSizeMin}.`;
      } else {
        // Store only file metadata in Redux (file name, size, type)
        newFiles.push({
          name: file.name,
          size: file.size,
          type: file.type,
        });
      }
    });

    if (newFiles.length + files.length > question.NoOfNumFile) {
      setError(`You can upload up to ${question.NoOfNumFile} files.`);
    } else {
      const updatedFiles = [...files, ...newFiles];
      setFiles(updatedFiles);

      const fileArray = Array.from(event.target.files);
      console.log(fileArray);
      // Dispatch to Redux
      dispatch(updateFiles({ questionId: question._id, files: fileArray }));
      setFileErrors((prevErrors) => ({ ...prevErrors, ...newFileErrors }));
    }
  };

  const parseFileSize = (sizeStr) => {
    const size = parseFloat(sizeStr);
    if (sizeStr.toLowerCase().includes("mb")) {
      return size * 1024 * 1024;
    }
    if (sizeStr.toLowerCase().includes("kb")) {
      return size * 1024;
    }
    return size;
  };

  const constructAcceptString = () => {
    let allowedTypes = [];

    // Handle mediaType condition
    if (question.mediaType === "Video") {
      allowedTypes.push("video/*");
    } else if (question.mediaType === "Audio") {
      allowedTypes.push("audio/*");
    } else {
      allowedTypes.push("audio/*", "video/*");
    }
    // Handle fileTypes condition
    if (question.fileTypes && question.fileTypes.length > 0) {
      allowedTypes = question.fileTypes.map(
        (type) => `.${type.trim().toLowerCase()}`
      );
    }

    return allowedTypes.join(",");
  };
  const handleDelete = (fileIndex) => {
    const fileName = files[fileIndex].name;
    setFiles(files.filter((_, index) => index !== fileIndex));
    // Dispatch to Redux
    dispatch(deleteFile({ questionId: question._id, fileIndex }));
    setFileErrors((errors) => {
      const newErrors = { ...errors };
      delete newErrors[fileName];
      return newErrors;
    });
  };

  const [hover, setHover] = useState(null);
  const maxLength = 20;
  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength) + "...";
  };

  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div className="fileUpload_container">
          <img src={formFileUploadIcon} alt="Upload Icon" />
          <div className="fileUpload_text_container">
            <p className="text">Select a file or drag and drop here</p>
            <p className="sndtext">{question.fileTypes}</p>
          </div>
          <input
            type="file"
            multiple
            id="file"
            name="files"
            onChange={handleFileChange}
            accept={constructAcceptString()}
            className="answer_file_select"
            style={{ display: "none" }} // Hide the default input
          />
          <label
            htmlFor="file"
            className="custom-file-label"
            style={{
              padding: "10px 20px",
              color: "#007BFF",
              backgroundColor: "#ffffff",
              border: "1px solid #007BFF",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Choose Files
          </label>
        </div>
        {error && <p className="error">{error}</p>}

        <div className="file-list">
          {files.map((file, index) => {
            const isExcessFile =
              files.length > question.NoOfNumFile &&
              index >= question.NoOfNumFile;
            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1.5rem",
                  color: isExcessFile ? "red" : "black",
                }}
              >
                <div
                  className={`Answer_file_upload_input ${
                    fileErrors[file.name] || isExcessFile ? "file-error" : ""
                  }`}
                  style={{ marginTop: "1rem" }}
                >
                  <p className="file_answer_container">
                    <img
                      src={documentresponse_icon}
                      alt="documentresponse_icon"
                    />
                    {file.name}
                    {truncateText(file.name, maxLength)}
                  </p>

                  {hover === index ? (
                    <img
                      src={trash_icon_del}
                      alt=""
                      onMouseLeave={() => setHover(null)}
                      onClick={() => handleDelete(index)}
                    />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onMouseOver={() => setHover(index)}
                    >
                      {fileErrors[file.name] || isExcessFile ? (
                        <img src={close_icon} alt="" />
                      ) : (
                        <img src={trash_icon} alt="" />
                      )}
                    </div>
                  )}
                  {fileErrors[file.name] && (
                    <p className="file-error-message">
                      {fileErrors[file.name]}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const FileUpload = ({ question, index }) => {
  const [files, setFiles] = useState([]);
  const dispatch = useDispatch();
  const [fileErrors, setFileErrors] = useState({});
  const [error, setError] = useState("");

  const handleFileChange = (event) => {
    setError("");
    const selectedFiles = Array.from(event.target.files);
    const validFileTypes = question.fileTypes
      ? question.fileTypes.map((type) => type.trim().toLowerCase())
      : []; // Default to empty if no fileTypes provided
    const maxFileSize = parseFileSize(question.fileSizeMax);
    const minFileSize = parseFileSize(question.fileSizeMin);

    let newFiles = [];
    let newFileErrors = {};

    selectedFiles.forEach((file) => {
      const fileType = file.type.split("/")[1].toLowerCase();
      if (validFileTypes.length > 0 && !validFileTypes.includes(fileType)) {
        newFileErrors[file.name] = `Invalid file type: ${
          file.name
        }. Allowed types are: ${validFileTypes.join(", ")}.`;
      } else if (file.size > maxFileSize) {
        newFileErrors[
          file.name
        ] = `File ${file.name} exceeds the maximum size of ${question.fileSizeMax}.`;
      } else if (file.size < minFileSize) {
        newFileErrors[
          file.name
        ] = `File ${file.name} is smaller than the minimum size of ${question.fileSizeMin}.`;
      } else {
        // Store only file metadata in Redux (file name, size, type)
        newFiles.push({
          name: file.name,
          size: file.size,
          type: file.type,
        });
      }
    });

    if (newFiles.length + files.length > question.NoOfNumFile) {
      setError(`You can upload up to ${question.NoOfNumFile} files.`);
    } else {
      const updatedFiles = [...files, ...newFiles];
      setFiles(updatedFiles);
      console.log(newFiles, files);

      const fileArray = Array.from(event.target.files);
      console.log(fileArray);
      // Dispatch to Redux
      dispatch(updateFiles({ questionId: question._id, files: fileArray }));
      setFileErrors((prevErrors) => ({ ...prevErrors, ...newFileErrors }));
    }
  };

  const parseFileSize = (sizeStr) => {
    const size = parseFloat(sizeStr);
    if (sizeStr.toLowerCase().includes("mb")) {
      return size * 1024 * 1024;
    }
    if (sizeStr.toLowerCase().includes("kb")) {
      return size * 1024;
    }
    return size;
  };

  const constructAcceptString = () => {
    let allowedTypes = [];

    // // Handle mediaType condition
    // if (question.mediaType === "Video") {
    //   allowedTypes.push("video/*");
    // } else if (question.mediaType === "Audio") {
    //   allowedTypes.push("audio/*");
    // } else {
    //   allowedTypes.push("audio/*", "video/*");
    // }
    // Handle fileTypes condition
    if (question.fileTypes && question.fileTypes.length > 0) {
      allowedTypes = question.fileTypes.map(
        (type) => `.${type.trim().toLowerCase()}`
      );
    }

    return allowedTypes.join(",");
  };
  const handleDelete = (fileIndex) => {
    const fileName = files[fileIndex].name;
    setFiles(files.filter((_, index) => index !== fileIndex));
    // Dispatch to Redux
    dispatch(deleteFile({ questionId: question._id, fileIndex }));
    setFileErrors((errors) => {
      const newErrors = { ...errors };
      delete newErrors[fileName];
      return newErrors;
    });
  };

  const [hover, setHover] = useState(null);
  const maxLength = 20;
  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength) + "...";
  };

  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div className="fileUpload_container">
          <img src={formFileUploadIcon} alt="Upload Icon" />
          <div className="fileUpload_text_container">
            <p className="text">Select a file or drag and drop here</p>
            <p className="sndtext">{question.fileTypes}</p>
          </div>
          <input
            type="file"
            multiple
            id="file"
            name="files"
            onChange={handleFileChange}
            accept={constructAcceptString()}
            className="answer_file_select"
            style={{ display: "none" }} // Hide the default input
          />
          <label
            htmlFor="file"
            className="custom-file-label"
            style={{
              padding: "10px 20px",
              color: "#007BFF",
              backgroundColor: "#ffffff",
              border: "1px solid #007BFF",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Choose Files
          </label>
        </div>
        {error && <p className="error">{error}</p>}

        <div className="file-list">
          {files.map((file, index) => {
            const isExcessFile =
              files.length > question.NoOfNumFile &&
              index >= question.NoOfNumFile;
            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1.5rem",
                  color: isExcessFile ? "red" : "black",
                }}
              >
                <div
                  className={`Answer_file_upload_input ${
                    fileErrors[file.name] || isExcessFile ? "file-error" : ""
                  }`}
                  style={{ marginTop: "1rem" }}
                >
                  <p className="file_answer_container">
                    <img
                      src={documentresponse_icon}
                      alt="documentresponse_icon"
                    />
                    {file.name}
                    {truncateText(file.name, maxLength)}
                  </p>

                  {hover === index ? (
                    <img
                      src={trash_icon_del}
                      alt=""
                      onMouseLeave={() => setHover(null)}
                      onClick={() => handleDelete(index)}
                    />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onMouseOver={() => setHover(index)}
                    >
                      {fileErrors[file.name] || isExcessFile ? (
                        <img src={close_icon} alt="" />
                      ) : (
                        <img src={trash_icon} alt="" />
                      )}
                    </div>
                  )}
                  {fileErrors[file.name] && (
                    <p className="file-error-message">
                      {fileErrors[file.name]}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const DateQuestion = ({ question, index, getAnswerValue }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showCalendar, setShowCalendar] = useState(false);
  const [inputValue, setInputValue] = useState(
    selectedDate.toISOString().substr(0, 10)
  ); // Format as YYYY-MM-DD
  const dispatch = useDispatch();
  const daysOfWeek = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };
  const handleDateClick = (questionId, day) => {
    const newDate = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      day
    );
    const value = newDate.toISOString().substr(0, 10);
    dispatch(dateUpdateResponse({ questionId, value }));
    setSelectedDate(newDate);
    setInputValue(newDate.toISOString().substr(0, 10));
    setShowCalendar(false);
  };

  const handleInputChange = (questionId, event) => {
    const value = event.target.value;
    setInputValue(value);
    dispatch(dateUpdateResponse({ questionId, value }));
    const [year, month, day] = value.split("-");
    const newDate = new Date(year, month - 1, day);
    if (!isNaN(newDate)) {
      setSelectedDate(newDate);
    }
  };

  const renderCalendar = () => {
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();
    const daysInMonth = getDaysInMonth(year, month);
    const firstDayOfMonth = new Date(year, month, 1).getDay();

    const days = [];
    for (let i = 0; i < firstDayOfMonth; i++) {
      days.push(<div key={`empty-${i}`} className="day empty"></div>);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const isSelected = day === selectedDate.getDate();
      days.push(
        <div
          key={day}
          className={`day ${isSelected ? "selected" : ""}`}
          onClick={() => handleDateClick(question._id, day)}
        >
          {day}
        </div>
      );
    }
    return (
      <div className="calendar">
        <div className="header">
          <button onClick={() => setSelectedDate(new Date(year, month - 1, 1))}>
            &lt;
          </button>
          <div>
            {months[month]} {year}
          </div>
          <button onClick={() => setSelectedDate(new Date(year, month + 1, 1))}>
            &gt;
          </button>
        </div>
        <div className="days-of-week">
          {daysOfWeek.map((day, index) => (
            <div key={index} className="day-of-week">
              {day}
            </div>
          ))}
        </div>
        <div className="days">{days}</div>
      </div>
    );
  };
  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div className="nameAns_container">
          <div
            className="calander"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <input
                type="date"
                id="customDate"
                name="customDate"
                value={inputValue}
                onChange={(e) => handleInputChange(question._id, e)}
                // onClick={() => setShowCalendar(!showCalendar)}
              />
              <img
                src={calendarIcon}
                alt="calendarIcon"
                className="calanderIcon"
                style={{ cursor: "pointer" }}
                onClick={() => setShowCalendar(!showCalendar)}
              />
            </div>
          </div>
        </div>
        {showCalendar && renderCalendar()}
      </div>
    </div>
  );
};

const DateAndTime = ({ question, index, getAnswerValue }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showCalendar, setShowCalendar] = useState(false);

  //time picker
  const [selectedTime, setSelectedTime] = useState(null);
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState(
    selectedDate.toISOString().substr(0, 10)
  ); // Format as YYYY-MM-DD

  const daysOfWeek = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };
  const handleDateClick = (day) => {
    const newDate = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      day
    );
    setSelectedDate(newDate);
    const offset = newDate.getTimezoneOffset() * 60000; // Get timezone offset in milliseconds
    const localISOTime = new Date(newDate.getTime() - offset)
      .toISOString()
      .substring(0, 10); // Adjust date and get ISO string
    setInputValue(localISOTime);
    dispatch(
      dateTimeResponses({ questionId: question._id, date: localISOTime })
    );
    setShowCalendar(false);
  };

  const handleInputChange = (event) => {
    const newValue = event.target.value;
    setInputValue(newValue);
    dispatch(
      dateTimeResponses({
        questionId: question._id,
        date: newValue,
      })
    );
    const [year, month, day] = newValue.split("-");
    const newDate = new Date(year, month - 1, day);
    newDate.setHours(0, 0, 0, 0);
    if (!isNaN(newDate)) {
      setSelectedDate(newDate);
    }
  };

  const renderCalendar = () => {
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();
    const daysInMonth = getDaysInMonth(year, month);
    const firstDayOfMonth = new Date(year, month, 1).getDay();

    const days = [];
    for (let i = 0; i < firstDayOfMonth; i++) {
      days.push(<div key={`empty-${i}`} className="day empty"></div>);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const isSelected = day === selectedDate.getDate();
      days.push(
        <div
          key={day}
          className={`day ${isSelected ? "selected" : ""}`}
          onClick={() => handleDateClick(day)}
        >
          {day}
        </div>
      );
    }
    return (
      <div className="calendar">
        <div className="header">
          <button onClick={() => setSelectedDate(new Date(year, month - 1, 1))}>
            &lt;
          </button>
          <div>
            {months[month]} {year}
          </div>
          <button onClick={() => setSelectedDate(new Date(year, month + 1, 1))}>
            &gt;
          </button>
        </div>
        <div className="days-of-week">
          {daysOfWeek.map((day, index) => (
            <div key={index} className="day-of-week">
              {day}
            </div>
          ))}
        </div>
        <div className="days">{days}</div>
      </div>
    );
  };

  const handleTimeChange = (newTime) => {
    const date = new Date(newTime);
    const hours = date.getHours() % 12 || 12; // Convert to 12-hour format
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Ensure 2 digits
    const period = date.getHours() >= 12 ? "PM" : "AM"; // Determine AM/PM
    const formattedTime = `${hours}:${minutes}:${period}`;
    setSelectedTime(formattedTime);
    dispatch(
      dateTimeResponses({
        questionId: question._id,
        time: formattedTime,
        date: inputValue,
      })
    );
  };

  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div className="nameAns_container">
          <div
            className="calander"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <input
                type="date"
                id="customDate"
                name="customDate"
                style={{ outline: "none", fontSize: "1.25rem" }}
                value={inputValue}
                onChange={handleInputChange}
              />
            </div>
            <img
              src={calendarIcon}
              alt="calendarIcon"
              className="calanderIcon"
              onClick={() => setShowCalendar(!showCalendar)}
            />
          </div>
          <div className="time">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["TimePicker"]}>
                <TimePicker
                  value={getAnswerValue(question._id)}
                  onChange={handleTimeChange}
                  viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                    seconds: renderTimeViewClock,
                  }}
                  slotProps={{
                    textField: {
                      sx: {
                        "& .MuiOutlinedInput-root": {
                          border: "none", // Remove border
                          "& fieldset": {
                            border: "none", // Remove the default fieldset border
                          },
                          "&:hover fieldset": {
                            border: "none", // Remove hover border
                          },
                          "&.Mui-focused fieldset": {
                            border: "none", // Remove focused border
                          },
                        },
                      },
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </div>
        </div>
        {showCalendar && renderCalendar()}
      </div>
    </div>
  );
};

const images = {
  star: startquestion_icon,
  balloon: balloonrating_icon,
  addIcon: addrating_icon,
  thumbsup: thumbsuprating_icon,
  heart: heartrating_icon,
  flag: flagrating_icon,
  basketball: basketballrating_icon,
  // Add other types and their images here
};
const selectedImage = {
  star: selected_startquestion_icon,
  balloon: selected_balloonrating_icon,
  addIcon: selected_addrating_icon,
  thumbsup: selected_thumbsuprating_icon,
  heart: selected_heartrating_icon,
  flag: selected_flagrating_icon,
  basketball: selected_basketballrating_icon,
  // Add other types and their images here
};

const Ratings = ({ question, index }) => {
  const [rating, setRating] = useState(0);
  const imageSrc = images[question.typeofdign];
  const selectedImageSrc = selectedImage[question.typeofdign];

  const handleRatingClick = (i) => {
    if (rating === i + 1) {
      setRating(0); // Remove the selection if the same image is clicked again
    } else {
      setRating(i + 1); // Set the new rating
    }
  };
  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div className="ratingimg_container">
          {Array.from({ length: question.count }).map((_, i) => (
            <img
              key={i}
              src={i < rating ? selectedImageSrc : imageSrc}
              alt={imageSrc}
              onClick={() => handleRatingClick(i)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const Dropdown = ({ question, index }) => {
  const dispatch = useDispatch();
  console.log(question);
  const handleUpdateOption = (event) => {
    dispatch(
      dropDownResponses({ questionId: question._id, value: event.value })
    );
  };
  console.log(question);
  const customStyles = {
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "#E0E7F7" : "#fff",
      ":hover": {
        backgroundColor: "none",
      },
    }),
  };
  return (
    <div className="answer_container">
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
        <div className="nameAns_container">
          <div
            className="calander"
            style={{
              display: "flex",
              justifyContent: "space-between",
              border: "none",
              padding: "none",
              paddingLeft: "0px",
            }}
          >
            <Select
              className="dropdown-select-tag"
              styles={customStyles}
              onChange={(e) => handleUpdateOption(e)}
              name="character"
              options={question.options.map((opt) => ({
                value: opt.optionText,
                label: opt.optionText,
              }))}
            />
            {/* <img src={drop_down} alt="calendarIcon" className="calanderIcon" /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export {
  ShortAnswer,
  ParagraphAnswer,
  MultipleChoice,
  CheckBox,
  GridBox,
  CheckBoxGrid,
  Phone,
  Name,
  Website,
  Email,
  Number,
  Spinner,
  Signature,
  FileUpload,
  VAFileUpload,
  DateQuestion,
  DateAndTime,
  Ratings,
  Dropdown,
  LineScale,
  Location,
  //   MultipleChoiceImage,
};
